import { useTranslation } from 'react-i18next';
import { Box, Container, Stack, Typography } from '@mui/material';
import { UserInfoForm } from '../forms';

const keyPrefix = 'pages.UserInfoPage';

export const UserInfoPage = () => {
  const { t } = useTranslation('translation', { keyPrefix });

  return (
    <Container maxWidth='lg'>
      <Box padding='32px 105px'>
        <Typography variant='h4' my={2}>
          {t('title')}
        </Typography>
        <Stack alignItems='center'>
          <Box width='582px'>
            {/* <Typography variant='body1'> {t('instructions')}</Typography> */}
          </Box>
          <Box width='582px'>
            <UserInfoForm />
          </Box>
        </Stack>
      </Box>
    </Container>
  );
};
